import jwt_decode from "jwt-decode";
import axios from "axios";
import { getToken } from "./tokenCheck";
// import store from "../store";
// import headerVUEX from "@/store/modules/headerVUEX";
// import store from "../../src/store/modules/headerVUEX"
// const loginHeader = store.getters["headerVUEX/getLoginHeader"];

// console.log("loginHeader ", store,store.getters["headerVUEX/getLoginHeader"],store.getters,store.state.headerVUEX.loginHeader);
const trainingServe = axios.create({
  baseURL: 
  // "https://training-api.simplifycv.com/", // development
  // "https://training-api.simplifymycareer.com/", // staging
  "https://training-api.hire3x.com/", // production
});

trainingServe.interceptors.request.use(
  (config) => {
    // config.headers["userID"] = "ed9c7555-5681-44b1-9cf0-e5094bada550";
    config.headers["userID"] = getProcessedToken();
    // const vueToken = localStorage.getItem("vue_token");

    // if (vueToken) {
    //   config.headers["userID"] = getProcessedToken();
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

trainingServe.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return error.response;
  }
);

// Base URL for Token API
const serviceSSO = axios.create({
  baseURL:
  //  "https://auth.simplifymycareer.com/", // development and staging
   "https://auth.hire3x.com/", // production
});

// Base URL for Forgot Password API
const SysToken = axios.create({
  baseURL: "https://keynode.hire3x.com/",
});

const ServiceCandidate = axios.create({
  // baseURL: "http://localhost:8000/" // Development
  baseURL:
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/candidate/", // Dev Gateway
    // "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/candidate/", // Staging
    "https://5ewlrd6mi7.execute-api.ap-south-1.amazonaws.com/final/candidate/" // Production
});

const paymentService = axios.create({
  baseURL: "https://payment.hire3x.com/",
});

ServiceCandidate.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

paymentService.interceptors.request.use(
  (config) => {
    config.headers["userID"] = getProcessedToken();
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

paymentService.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return error.response;
  }
);
function getProcessedToken() {
  try {
    const decoded = jwt_decode(getToken());
    return decoded.sub;
  } catch (error) {
    return null;
  }
}
export {
  trainingServe,
  serviceSSO,
  SysToken,
  getProcessedToken,
  ServiceCandidate,
  paymentService,
};
